export default "__VITE_PUBLIC_ASSET__0058a185__"